import React from "react";
import { Link } from "react-router-dom";
import "./allResultsCard.css";
import { ContentItem } from "../../data/registry";

interface AllResultsCardProps {
  results: ContentItem[];
}

const ORIGIN = window.location.origin;

const AllResultsCard = ({ results }: AllResultsCardProps) => {
  function formatURL(u: string): [string, string[]] {
    try {
      const url = new URL(u);
      const domain = url.origin;
      const paths = url.pathname.split('/').filter(Boolean);
      return [domain, paths];
    } catch {
      return [u, []];
    }
  }

  function isInternal(link: string): boolean {
    return link.startsWith(ORIGIN) || link.startsWith("/");
  }

  function getInternalPath(link: string): string {
    if (link.startsWith(ORIGIN)) {
      return link.slice(ORIGIN.length) || "/";
    }
    return link;
  }

  return (
    <div className="results-content">
      {results.map((item) => (
        <div key={item.name} className="result-card">
          {isInternal(item.link) ? (
            <Link to={getInternalPath(item.link)}>
              <p className="url">
                {formatURL(item.link)[0]}
                {formatURL(item.link)[1].map((p) => (
                  <span key={p}>{` › ${p}`}</span>
                ))}
              </p>
              <h3>{item.name}</h3>
            </Link>
          ) : (
            <a href={item.link} target="_blank" rel="noopener noreferrer">
              <p className="url">
                {formatURL(item.link)[0]}
                {formatURL(item.link)[1].map((p) => (
                  <span key={p}>{` › ${p}`}</span>
                ))}
              </p>
              <h3>{item.name}</h3>
            </a>
          )}
          <p className="meta">
            {item.isNew && <span className="pill">New</span>}
            <span className="date">{item.date}</span>
          </p>

          {item.bullets && (
            <ul className="bullets">
              {item.bullets.map((b) => (
                <li key={b}>{b}</li>
              ))}
            </ul>
          )}

          {item.excerpt && <p className="excerpt">{item.excerpt}</p>}
        </div>
      ))}
    </div>
  );
};

export default AllResultsCard;
